import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PublicRoutes from './PublicRoutes';

// ==============================|| ROUTING RENDER ||============================== //

// Served from the domain root. This was an env var (VITE_APP_BASE_NAME) left
// over from the Mantis template, which needed it to deploy under /free — we
// don't, and the project deliberately has no .env files.
//
// Three top-level trees sharing '/': MainRoutes (authenticated app, now at
// /dashboard) and LoginRoutes (auth forms) both existed before; PublicRoutes
// (the marketing site) now owns the bare '/' itself, since MainRoutes no
// longer has anything registered there.
const router = createBrowserRouter([MainRoutes, LoginRoutes, PublicRoutes], { basename: '/' });

export default router;
